import { grey } from "@material-ui/core/colors";
import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  bar: {
    position: "fixed",
    left: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100vw",
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
    zIndex: theme.zIndex.drawer + 1,
    padding: theme.spacing(0, 3),
  },
  connectButton: {
    background: theme.palette.common.white,
    color: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: grey[200],
    },
    "&+&": {
      marginLeft: theme.spacing(2),
    },
  },
}));
